import {SidebarUsedBy as UsedByComponent} from '@github-ui/code-view-sidebar/components/SidebarUsedBy'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarUsedBy({ownerLogin, repoName}: Props) {
  const {usedBy} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!usedBy) return null
  return <UsedByComponent {...usedBy} />
}
